export default __webpack_public_path__ + "static/media/close-red.6af81a8a.svg";